import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { QueryProvider } from './providers/query-provider';
import { Web3Provider } from './providers/web3-provider';
import { useUIStore } from './stores';
import './index.css';

// Simple loading component
function AppLoading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#0a0a0a',
      }}
    >
      <div style={{ color: '#fff', fontSize: '1rem' }}>Loading...</div>
    </div>
  );
}

// Initialize Zustand stores on app mount
function AppRoot() {
  useEffect(() => {
    // Initialize theme from Zustand store
    const theme = useUIStore.getState().theme;
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, []);

  return (
    <QueryProvider>
      <Suspense fallback={<AppLoading />}>
        <Web3Provider>
          <App />
        </Web3Provider>
      </Suspense>
    </QueryProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);
